var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNlFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.432,
    height: 22.381,
    viewBox: "0 0 34.432 22.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NL-Flag",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4099",
    "data-name": "Rectangle 4099",
    width: 34.433,
    height: 7.461,
    transform: "translate(0 7.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4100",
    "data-name": "Rectangle 4100",
    width: 34.433,
    height: 7.459,
    transform: "translate(0 0)",
    fill: "#aa1928"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4101",
    "data-name": "Rectangle 4101",
    width: 34.433,
    height: 7.461,
    transform: "translate(0 14.92)",
    fill: "#1e4b87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlFlag);
export default __webpack_public_path__ + "static/media/NL-Flag.1296fcca4ecb0fffc8216534630321da.svg";
export { ForwardRef as ReactComponent };